import React, { useContext, useEffect, useState } from "react";
import styles from "./styles/Beneficiaries.module.css";
import InfoTitle from "../Info/InfoTitle";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { PageHeading } from "../PartnerNav/PageHeading";

function Beneficiaries() {
  window.scrollTo(0, 0);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.Beneficiaries.Beneficiaries
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.Beneficiaries.Beneficiaries);
  }, [websiteCurrentLang]);

  return (
    <div className={styles.main_box}>
      <PageHeading
        className={styles.page_title}
        title={content?.beneficiariesTitle1}
      />
      <InfoTitle
        message={content.beneficiariesText1}
        title={content.beneficiariesText2}
      />
    </div>
  );
}

export default Beneficiaries;
